const dsSearch = (($) => {


    const base_url = 'index.php?route=product/search&';

    function getPreviousSearches(header) {
        const hasStorage = dsUtilities.hasStorage('sessionStorage');
        if (!hasStorage || (hasStorage && sessionStorage.getItem('dsPrev') === null)) {
            ajaxPreviousSearches().done(function (terms) {
                writePreviousSearches(terms, header, true)
            });
        } else {
            writePreviousSearches(JSON.parse(sessionStorage.getItem('dsPrev')), header, false);
        }
    }

    function doSearch(request) {
        ajaxSearch(request).done(function(response) {
            writeSearches(response, request);
        });
    }

    function storageUnset(data) {
        if (dsUtilities.hasStorage('sessionStorage')) {
            sessionStorage.removeItem(data);
        }
    }

    function ajaxPreviousSearches() {
        return $.ajax({
            type: 'GET',
            url: doorstep.api + 'search/previous/' + doorstep.customer_id,
            dataType: 'json'
        });
    }

    function writePreviousSearches(terms, header, write_to_ls) {
        if (dsUtilities.hasStorage('sessionStorage') && write_to_ls) {
            sessionStorage.setItem('dsPrev', JSON.stringify(terms));
        }
        terms.forEach(function(term) {
            $(header).find('div.previous-searches').append(`<a href="index.php?route=product/search&search=${term}" class="search-link">${term}</a>`);
        });
    }

    function ajaxSearch(request) {
        return $.ajax({
            type: 'GET',
            url: doorstep.api + 'search/request/' + doorstep.customer_id + '/' + request,
            dataType: 'json'
        });
    }

    function writeSearches(response, request) {
        const div = 'div.search-autocomplete';
        let html = '';
        $(div).html('');
        if (response.products.length) {
            response.products.forEach(function(product) {
                const link = product.gv ? 'index.php?route=account/gift_voucher' : product.slug
                html += `<a href="${link}" class="search-link search-link--colum"><img src="${product.image}" height="48" alt="${product.name}" class="algolia-search-image">${product.name}</a>`;
            });
            html += `<a href="${base_url}search=${request}" class="search-link search-link--colum view-more-link">View more</a>`;
        }
        if (response.tags.length) {
            html += `<p class="search-title search-title--mt">Filters</p>`;
            response.tags.forEach(function(tag) {
                html += `<a href="${base_url}tag=${tag}" class="search-categories">${tag}</a>`;
            });
        }
        if (response.categories.length) {
            html += `<p class="search-title search-title--mt">Categories</p>`;
            response.categories.forEach(function(category) {
                html += `<a href="${category.slug}?search=${request}" class="search-categories"><img src="/image/${category.image}" alt="${category.name}">${category.name}</a>`;
            });
        }
        $(div).append(html);
    }

    function linkSearchPage(el) {
        const request = $(el).closest('header').find('input.search-input').val().trim();
        if (request.length > 0) {
            location.href = 'index.php?route=product/search&search=' + request;
        }
    }

    function search_delay(callback, ms) {
        var timer = 0;
        return function() {
            var context = this, args = arguments;
            clearTimeout(timer);
            timer = setTimeout(function () {
                callback.apply(context, args);
            }, ms || 0);
        };
    }

    function searchKeystrokes(el) {
        const request = $(el).val();
        if (request.length > 2) {
            doSearch(request);
        }
        if (request != '') {
            $('.search-drop').removeClass('search-focus');
            $('.search-autocomplete').addClass('search-focus');
            $('div.search').addClass('search-input-drop');
        } else {
            $('.search-drop').addClass('search-focus');
            $('.search-autocomplete').removeClass('search-focus');
            $('div.search').removeClass('search-input-drop');
        }
    }

    function searchBoxDisplay(el) {
        const header = $(el).closest('header');
        if (!$(header).find('div.previous-searches').html().length) {
            getPreviousSearches(header);
        }
        if ($(el).val() != '') {
            $('.search-drop').removeClass('search-focus');
            $('.search-autocomplete').addClass('search-focus');
        }
        $('.search-drop').addClass('search-focus');
        $('.search-input').css({ borderBottomLeftRadius: 0, borderBottomRightRadius: 0});
        if($('.search').innerWidth() <= 479) {
            let elemHeder = $('.header').find('.search-drop').children('.search-link');
            for (let i=3; i<elemHeder.length; i++) {
                elemHeder.eq(i).css({ display: 'none'});
            }
            let elemMiniHeader = $('#mini-header').find('.search-drop').children('.search-link');
            for (let i=3; i<elemMiniHeader.length; i++) {
                elemMiniHeader.eq(i).css({ display: 'none'});
            }
        }
    }

    function searchBoxFocus() {
        $('.search-menu').removeClass('hide');
        $('div#search-pagination').removeClass('hide');
    }

    function searchBoxClicked(e) {
        if (!$(e.target).closest(".search").length) {
            $('.search-menu').addClass('hide');
            $('.search-drop').removeClass('search-focus');
        }
    }

    function categoryHTML(category) {
        return `
            <a class="${category.cssClasses.link}" href="${category.url}">` + (category.image !== undefined && category.image.length > 0 ? '<img src="' + category.image + '">' : '') +
            `<span class="${category.cssClasses.label}">${category.label}</span>
                <span class="${category.cssClasses.count}">${category.count.toLocaleString()}</span>
            </a>`;
    }

    function categoryImage(category) {
        if (doorstep.category_images[category.label] !== undefined) {
            return '/image/' + doorstep.category_images[category.label];
        }
        return '';
    }

    $(document).ready(function() {

        $('img.search-icon').on('click', function() {
            linkSearchPage($(this));
        });

        $('.search-input').on('keypress', function(e) {
            if (e.which === 13) {
                linkSearchPage($(this));
            }
        });

        $('.search-input-box').focusin(function () {
            searchBoxFocus();
        });

        $(document).on('click', function (e) {
            searchBoxClicked(e);
        });

        $('.search-input').keyup(search_delay(function () {
            searchKeystrokes($(this));
        }, 500));

        $('.search-input').focusin(function () {
            searchBoxDisplay($(this));
        });

        $(document).on('click', function (e) {
            if (!$(e.target).closest(".search").length) {
                $('.search-drop').removeClass('search-focus');
                $('.search-autocomplete').removeClass('search-focus');
                $('div.search').removeClass('search-input-drop');
                $('.search-input').css({ borderBottomLeftRadius: 24, borderBottomRightRadius: 24});
            }
        });

    });

    return {
        getPreviousSearches   : getPreviousSearches,
        doSearch              : doSearch,
        storageUnset          : storageUnset
    }

})(jQuery);